import React from 'react';
import PropTypes from 'prop-types';

import Chart, {
  Series,
  Legend,
  CommonSeriesSettings,
  Point,
  ArgumentAxis,
  Size,
  Tooltip
} from 'devextreme-react/chart';

import RangeSelector, {
  Chart as ChartOptions,
  Margin,
  Scale,
  Behavior,
} from 'devextreme-react/range-selector';

class LineGraphSlider extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      visualRange: { 
        startValue: this.props.analysisGraph[0].date, 
        endValue: this.props.analysisGraph[this.props.analysisGraph.length - 1].date }
    };
    this.updateVisualRange = this.updateVisualRange.bind(this);
  }
  updateVisualRange(e) {
    this.setState({ visualRange: e.value });
  }

  render() {
    return (
      <React.Fragment>
        <Chart
          id="zoomedChart"
          palette="Harmony Light"
          dataSource={this.props.analysisGraph}
        >
          <Series argumentField="date" valueField="testPercent" />
          <ArgumentAxis visualRange={this.state.visualRange} />
          <Legend visible={false} />
          <CommonSeriesSettings>
            <Point size={7} />
          </CommonSeriesSettings>
          <Size height={250} />
          <Tooltip enabled={true} />
        </Chart>
        <RangeSelector
          dataSource={this.props.analysisGraph}
          onValueChanged={this.updateVisualRange}
        >
          <Size height={70} />
          <Margin top={10} />
          <Scale
            minorTickCount={1}
            startValue={this.props.analysisGraph[0].date}
            endValue={
              this.props.analysisGraph[this.props.analysisGraph.length - 1].date
            }
          />
          <ChartOptions palette="Harmony Light">
            <Behavior callValueChanged="onMoving" />
            <Legend visible={false} />
            <Series argumentField="date" valueField="testPercent" />
          </ChartOptions>
        </RangeSelector>
      </React.Fragment>
    );
  }
}

export default LineGraphSlider;
LineGraphSlider.propTypes = {
  analysisGraph: PropTypes.array,
};
